import { render } from "./CreateModalMenuItem.vue?vue&type=template&id=622a015a&scoped=true"
import script from "./CreateModalMenuItem.vue?vue&type=script&lang=js"
export * from "./CreateModalMenuItem.vue?vue&type=script&lang=js"

import "./CreateModalMenuItem.vue?vue&type=style&index=0&id=622a015a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622a015a"]])

export default __exports__